import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { profileApi } from '../api/profileApi'
import type { UpdateProfileDto, ChangePasswordDto, DeleteAccountDto } from '@fp3/shared'
import { useAuth } from '@/modules/auth/hooks/useAuth'

export const useProfile = () => {
  return useQuery({
    queryKey: ['profile'],
    queryFn: profileApi.getProfile,
  })
}

export const useUpdateProfile = () => {
  const queryClient = useQueryClient()
  const { updateUser } = useAuth()
  return useMutation({
    mutationFn: (dto: UpdateProfileDto) => profileApi.updateProfile(dto),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['profile'] })
      updateUser({ name: data.name ?? '', avatar: data.avatar })
    },
  })
}

export const useChangePassword = () => {
  return useMutation({
    mutationFn: (dto: ChangePasswordDto) => profileApi.changePassword(dto),
  })
}

export const useDeleteUser = () => {
  const { logout } = useAuth()
  return useMutation({
    mutationFn: (dto: DeleteAccountDto) => profileApi.deleteUser(dto),
    // here rather than in a mutate() callback: those are dropped once their observer resets, and
    // the session has to end whenever the account is gone
    onSuccess: () => logout(),
  })
}
